export default class EmailInUseError extends Error {
  name = 'EmailInUseError';

  constructor(readonly message = 'Email Already in Use') {
    super(message);
  }
}
